import githubLogo from './images/gh-logo.png';
import collegeLogo from './images/College image.jpeg'
import bubbleSort1 from './images/bubble.png'
import bucketSort from './images/bucketsort.png';
import combSort from './images/combsort.png';
import countSort from './images/count.png'
import gnomeSort from './images/gnomesort.png'
import heapSort1 from './images/heap1.png'
import heapSort2 from './images/heap2.png'
import heapSort3 from './images/heap3.png'
import insertionSort from './images/insertion.png';
import kWayExternal from './images/kwayexternal.png'
import mergeSort1 from './images/merge1.png'
import mergeSort2 from './images/merge2.png'
import quickSort from './images/quick.png';
import radixSort from './images/radix.png'
import replacementSort from './images/replacementselection.png'
import selectionSort from './images/selection.png'
import stoogeSort from './images/stoogesort.png'
import strandSort from './images/strandsort.png'

const assets = {
  images: {
    githubLogo: githubLogo,
    collegeLogo: collegeLogo,
    bubbleSort1:bubbleSort1,
    bucketSort:bucketSort,
    combSort:combSort,
    countSort:countSort,
    gnomeSort:gnomeSort,
    heapSort1:heapSort1,
    heapSort2:heapSort2,
    heapSort3:heapSort3,
    insertionSort:insertionSort,
    kWayExternal:kWayExternal,
    mergeSort1:mergeSort1,
    mergeSort2:mergeSort2,
    quickSort:quickSort,
    radixSort:radixSort,
    replacementSort:replacementSort,
    selectionSort:selectionSort,
    stoogeSort:stoogeSort,
    strandSort:strandSort
  },
};

export default assets;
